import { TraceabilityPallet } from './traceability-pallet.model'
import { TraceabilityStock } from './traceability-stock.model'
import { TraceabilityCategory } from './traceability-category.model'
import * as utils from '../../../core/utils/utils'
import { TraceabilityReception } from './traceability-reception.model'

export class Traceability {
  /** Business unit number */
  batchBU: string

  /** Site code */
  site: string

  /** Prod line N° */
  prodLine: string

  /** Internal batch number */
  internalBatchNumber: string

  /** Short article code */
  shortArticleCode: string

  /** Long article code */
  articleCode: string

  /** Article description */
  articleDesc: string

  /** Batch class */
  batchClass: string

  /** Class description */
  classDesc: string

  /** Supplier batch number */
  supplierBatchNumber: string

  /** Supplier code */
  supplierCode: string

  /** Supplier name */
  supplierName: string

  /** Product's location **/
  // orig: string

  /** OF number */
  workOrder: String

  /** OF type */
  workOrderType: string

  /** Reception date */
  receptionDate: string
  get receptionDateAsDate(): Date {
    return utils.strDateToDate(this.receptionDate)
  }

  /** Produced qty (primary) */
  producedQuantity: { value: string; unit: string }

  /** received qty (primary) */
  receivedQuantity: { value: string; unit: string }

  /** Produced qty (secondary) */
  producedQuantitySecondary: { value: string; unit: string }

  /** Received qty (secondary) */
  receivedQuantitySecondary: { value: string; unit: string }

  /** Category (computed with GL key) */
  category: TraceabilityCategory

  /** Batch number of the parent component (WO) */
  parentBatchNumber: string

  /** Starting production date and time */
  prodStartDateTime: string
  get prodStartDateTimeAsDate(): Date {
    return utils.strDateTimeToDate(this.prodStartDateTime)
  }

  /** Ending production date and time */
  prodEndDateTime: string
  get prodEndDateTimeAsDate(): Date {
    return utils.strDateTimeToDate(this.prodEndDateTime)
  }

  /** Parents of this batch (through reclassification) */
  reclassifiedParents: string[]

  /** Parents of this batch */
  parents: string[]

  /** Children of this batch (through reclassification) */
  reclassifiedChildren: string[]

  /** Parents of this batch */
  children: string[]

  /** List of pallets associated to this batch */
  pallets: TraceabilityPallet[]

  /** List of stocks */
  stock: TraceabilityStock[]

  /** Is this traceability's internalBatchNumber a part of the original request */
  origin: boolean

  /** Whether the item is selected or not */
  selected?: boolean

  /** Receptions details from AGREO */
  receptions: TraceabilityReception[]

  constructor(traceability: Traceability) {
    this.batchBU = traceability.batchBU || ''
    this.site = traceability.site || ''
    this.prodLine = traceability.prodLine || ''
    this.internalBatchNumber = traceability.internalBatchNumber || ''
    this.shortArticleCode = traceability.shortArticleCode || ''
    this.articleCode = traceability.articleCode || ''
    this.articleDesc = traceability.articleDesc || ''
    this.supplierBatchNumber = traceability.supplierBatchNumber || ''
    // this.orig = traceability.orig || ''
    this.batchClass = traceability.batchClass || ''
    this.classDesc = traceability.classDesc || ''
    this.supplierCode = traceability.supplierCode || ''
    this.supplierName = traceability.supplierName || ''
    this.workOrder = traceability.workOrder || ''
    this.workOrderType = traceability.workOrderType || ''
    this.receptionDate = traceability.receptionDate || ''
    this.producedQuantity =
      traceability.producedQuantity &&
      traceability.producedQuantity.value !== '0'
        ? traceability.producedQuantity
        : null
    this.receivedQuantity =
      traceability.receivedQuantity &&
      traceability.receivedQuantity.value !== '0'
        ? traceability.receivedQuantity
        : null
    this.producedQuantitySecondary =
      traceability.producedQuantitySecondary &&
      traceability.producedQuantitySecondary.value !== '0'
        ? traceability.producedQuantitySecondary
        : null
    this.receivedQuantitySecondary =
      traceability.receivedQuantitySecondary &&
      traceability.receivedQuantitySecondary.value !== '0'
        ? traceability.receivedQuantitySecondary
        : null
    this.category = new TraceabilityCategory(traceability.category)
    this.parentBatchNumber = traceability.parentBatchNumber || ''
    this.prodStartDateTime = traceability.prodStartDateTime || ''
    this.prodEndDateTime = traceability.prodEndDateTime || ''
    this.reclassifiedParents = traceability.reclassifiedParents || []
    this.parents = traceability.parents || []
    this.reclassifiedChildren = traceability.reclassifiedChildren || []
    this.children = traceability.children || []
    this.pallets = traceability.pallets || []
    this.stock = traceability.stock || []
    this.origin = traceability.origin || false
    this.selected = traceability.selected || false
    this.receptions = traceability.receptions || []
    // Parse arrays' items to make sure we have a class instance instead of a simple js object
    this.pallets = this.pallets.map((p) => new TraceabilityPallet(p))
    this.stock = this.stock.map((s) => new TraceabilityStock(s))
    this.receptions = this.receptions.map((r) => {
      return new TraceabilityReception(r)
    })
  }
}
